export default __webpack_public_path__ + "static/7435-83d0a8e02129294f76c87666b3022f15.jpg";